import { CommonError } from '@trustedshops/tswp-core-common';

export interface PluginLoadError extends CommonError {
  readonly pluginName: string;
}
